import { Polyglot } from 'components/translate';
import moment from 'moment';

// #region select data
let classesList = [];
let quizzesExerciseList = [];
let quizzesProfileList = [];
let modulesTreeList = [];

const setClassesList = (value) => {
  classesList = value;
};

const setQuizzesExerciseList = (value) => {
  quizzesExerciseList = value;
};

const setQuizzesProfileList = (value) => {
  quizzesProfileList = value;
};

const setModulesTreeList = (value) => {
  modulesTreeList = value && value[0].pages ? value[0].pages : [];
};

const findByKeyInList = (keyName, list, value) =>
  list.find((item) => item[keyName] === value);

// #endregion

// #region filters finders and formatters
const filtersOptions = () => ({
  userStatus: [
    {
      value: '',
      label: Polyglot.t('users_manager.users_list.header.tab_all_users')
    },
    {
      value: 'ACTIVE',
      label: Polyglot.t(
        'users_manager.deep_search.access.access_options.active'
      )
    },
    {
      value: 'BLOCKED',
      label: Polyglot.t(
        'users_manager.deep_search.access.access_options.blocked'
      )
    },
    {
      value: 'BLOCKED_BY_OWNER',
      label: Polyglot.t(
        'users_manager.deep_search.access.access_options.blocked_by_owner'
      )
    },
    {
      value: 'OVERDUE',
      label: Polyglot.t(
        'users_manager.deep_search.access.access_options.overdue'
      )
    }
  ],
  userPlusAccess: [
    {
      value: 'DEPENDENT',
      label: Polyglot.t(
        'users_manager.deep_search.access.access_plus_type_user_options.dependants'
      )
    },
    {
      value: 'HOLDER_WITHOUT_DEPENDENTS',
      label: Polyglot.t(
        'users_manager.deep_search.access.access_plus_type_user_options.holder_without_dependants'
      )
    },
    {
      value: 'HOLDER_WITH_DEPENDENTS',
      label: Polyglot.t(
        'users_manager.deep_search.access.access_plus_type_user_options.holder_with_dependants'
      )
    },
    {
      value: 'WITHOUT_PLUS_ACCESS',
      label: Polyglot.t('general.no')
    },
    {
      value: 'ALL',
      label: Polyglot.t('general.all')
    }
  ],
  dateInterval: [
    {
      value: 'LAST_30',
      label: Polyglot.t(
        'users_manager.deep_search.access.period_options.last_days',
        { data: { days: '30' } }
      )
    },
    {
      value: 'LAST_60',
      label: Polyglot.t(
        'users_manager.deep_search.access.period_options.last_days',
        { data: { days: '60' } }
      )
    },
    {
      value: 'LAST_90',
      label: Polyglot.t(
        'users_manager.deep_search.access.period_options.last_days',
        { data: { days: '90' } }
      )
    },
    {
      value: 'LAST_180',
      label: Polyglot.t(
        'users_manager.deep_search.access.period_options.last_days',
        { data: { days: '180' } }
      )
    },
    {
      value: 'LAST_365',
      label: Polyglot.t(
        'users_manager.deep_search.access.period_options.last_days',
        { data: { days: '365' } }
      )
    }
  ],
  locale: [
    {
      value: 'pt_BR',
      label: Polyglot.t('supported_languages.PT')
    },
    {
      value: 'en',
      label: Polyglot.t('supported_languages.EN')
    },
    {
      value: 'es',
      label: Polyglot.t('supported_languages.ES')
    },
    {
      value: 'fr',
      label: Polyglot.t('supported_languages.FR')
    },
    {
      value: 'ar',
      label: Polyglot.t('supported_languages.AR')
    },
    {
      value: 'ru',
      label: Polyglot.t('supported_languages.RU')
    },
    {
      value: 'de',
      label: Polyglot.t('supported_languages.DE')
    },
    {
      value: 'ja',
      label: Polyglot.t('supported_languages.JA')
    },
    {
      value: 'it',
      label: Polyglot.t('supported_languages.IT')
    },
    {
      value: 'zh',
      label: Polyglot.t('supported_languages.ZH')
    }
  ],
  userType: [
    {
      value: 'BUYER',
      label: Polyglot.t(
        'users_manager.deep_search.access.category_options.buyer'
      )
    },
    {
      value: 'FREE',
      label: Polyglot.t('general.free')
    },
    {
      value: 'GUEST',
      label: Polyglot.t(
        'users_manager.deep_search.access.category_options.guest'
      )
    },
    {
      value: 'IMPORTED',
      label: Polyglot.t(
        'users_manager.deep_search.access.category_options.imported'
      )
    },
    {
      value: '',
      label: Polyglot.t('general.all')
    }
  ]
});

const findUserStatus = (value) => {
  const currentStatus = filtersOptions().userStatus.find(
    (object) => object.value === value
  );

  return currentStatus.label;
};

const findUserPlusAccess = (value) => {
  const currentStatus = filtersOptions().userPlusAccess.find(
    (object) => object.value === value
  );

  return currentStatus.label;
};

const formatDateInterval = (date) => {
  if (date.dateFilterType) {
    const currentStatus = filtersOptions().dateInterval.find(
      (object) => object.value === date.dateFilterType
    );

    if (currentStatus) {
      return currentStatus.label;
    } else {
      return Polyglot.t('users_manager.deep_search.access.between_dates', {
        data: {
          beginDate: moment.utc(date.from).format('L'),
          endDate: moment.utc(date.until).format('L')
        }
      });
    }
  }
};

const formateLocale = (value) => {
  const currentStatus = filtersOptions().locale.find(
    (object) => object.value === value
  );

  return currentStatus.label;
};

const formatUserType = (value) => {
  const currentStatus = filtersOptions().userType.find(
    (object) => object.value === value
  );

  return currentStatus.label;
};

const formatPages = (filtersGroup) => {
  const filterPages = filtersGroup.filter((filter) => filter._type === 'page');

  const pages = filterPages.reduce((pagesIds, page) => {
    const pageIds = page.ids.map((id) => {
      return {
        id,
        completed: page.completed
      };
    });

    return pagesIds.concat(pageIds);
  }, []);

  return {
    _type: 'page',
    pages
  };
};
// #endregion

// #region filters rules
const filtersRules = {
  content: [
    {
      title: 'user_progress',
      value: (filter) =>
        Polyglot.t('broadcast.filters_titles.percentage_interval', {
          min: filter.min,
          max: filter.max
        })
    },
    {
      title: 'user_class',
      value: (filter) => {
        const classFound = findByKeyInList('value', classesList, filter.ids[0]);

        return classFound && classFound.label;
      }
    },
    {
      title: 'page',
      values: (filter) => {
        return filter.pages.map((page) => {
          const pageFound = findByKeyInList('id', modulesTreeList, page.id);

          return (
            pageFound && {
              title: pageFound.name,
              status: page.completed
                ? Polyglot.t('general.concluded')
                : Polyglot.t('general.non_concluded')
            }
          );
        });
      }
    },
    {
      title: 'quiz_score',
      values: (filter) => {
        if (filter.ids) {
          return filter.ids.map((id) => {
            const quiz = findByKeyInList('id', quizzesExerciseList, id);

            return (
              quiz && {
                title: quiz.name,
                status: Polyglot.t(
                  'broadcast.filters_titles.grade_percentage_interval',
                  {
                    min: filter.min,
                    max: filter.max
                  }
                )
              }
            );
          });
        } else if (filter.id) {
          const quiz = findByKeyInList('id', quizzesExerciseList, filter.id);

          return (
            quiz && [
              {
                title: quiz.name,
                status: Polyglot.t(
                  'broadcast.filters_titles.grade_percentage_interval',
                  {
                    min: filter.min,
                    max: filter.max
                  }
                )
              }
            ]
          );
        }
      }
    },
    {
      title: 'quiz_profile',
      value: (filter) => {
        const quiz = findByKeyInList('id', quizzesProfileList, filter.id);

        return quiz && quiz.name;
      },
      status: (filter) => {
        if (filter) {
          const quizProfile = findByKeyInList(
            'id',
            quizzesProfileList,
            filter.profileId
          );

          return (
            quizProfile &&
            Polyglot.t('broadcast.filters_titles.profile_type', {
              profileType: quizProfile.name
            })
          );
        }
      }
    }
  ],
  access: [
    {
      title: 'user_purchase_date',
      value: (filter) => formatDateInterval(filter)
    },
    {
      title: 'user_first_access',
      value: (filter) => formatDateInterval(filter)
    },
    {
      title: 'user_last_access',
      value: (filter) => formatDateInterval(filter)
    },
    {
      title: 'user_status',
      value: (filter) => findUserStatus(filter.query)
    },
    {
      title: 'user_plus_access',
      value: (filter) => findUserPlusAccess(filter.value)
    }
  ],
  user: [
    {
      title: 'user_name',
      value: (filter) => filter.query
    },
    {
      title: 'user_email',
      value: (filter) => filter.query
    },
    {
      title: 'user_locale',
      value: (filter) => formateLocale(filter.query)
    },
    {
      title: 'user_join_type',
      value: (filter) => formatUserType(filter.query)
    },
    {
      title: 'user_type',
      value: (filter) => formatUserType(filter.query)
    },
    {
      title: 'user_engagement',
      value: (filter) =>
        Polyglot.t('broadcast.filters_titles.percentage_interval', {
          data: { min: filter.min, max: filter.max }
        })
    }
  ]
};
// #endregion

export {
  filtersRules,
  setClassesList,
  setQuizzesExerciseList,
  setQuizzesProfileList,
  setModulesTreeList,
  formatPages,
  filtersOptions
};
